/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero API
 * Legacy Impero .NET API (served under /v1).
 */
import { useMutation } from "@tanstack/react-query";
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    LegacyConfirmationControlViewModel,
    LegacyControl,
    LegacyControlConfirmationData,
    LegacyControlControllerPostNextOccurrence,
    LegacyNextOccurrence,
} from "../model";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
    (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
    [P in keyof T]-?: IfEquals<
        { [Q in P]: T[P] },
        { -readonly [Q in P]: T[P] },
        P
    >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
    k: infer I
) => void
    ? I
    : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
    ? {
          [P in keyof Writable<T>]: T[P] extends object
              ? NonReadonly<NonNullable<T[P]>>
              : T[P];
      }
    : DistributeReadOnlyOverUnions<T>;

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const legacyControlConfirmationData = (
    legacyConfirmationControlViewModel?: NonReadonly<LegacyConfirmationControlViewModel>,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyControlConfirmationData>> => {
    return axios.post(
        `/v1/Control/ConfirmationData`,
        legacyConfirmationControlViewModel,
        options
    );
};

export const getLegacyControlConfirmationDataMutationOptions = <
    TError = AxiosError<void>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyControlConfirmationData>>,
        TError,
        { data?: NonReadonly<LegacyConfirmationControlViewModel> },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyControlConfirmationData>>,
    TError,
    { data?: NonReadonly<LegacyConfirmationControlViewModel> },
    TContext
> => {
    const mutationKey = ["legacyControlConfirmationData"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyControlConfirmationData>>,
        { data?: NonReadonly<LegacyConfirmationControlViewModel> }
    > = (props) => {
        const { data } = props ?? {};

        return legacyControlConfirmationData(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyControlConfirmationDataMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlConfirmationData>>
>;
export type LegacyControlConfirmationDataMutationBody =
    | NonReadonly<LegacyConfirmationControlViewModel>
    | undefined;
export type LegacyControlConfirmationDataMutationError = AxiosError<void>;

export const useLegacyControlConfirmationData = <
    TError = AxiosError<void>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyControlConfirmationData>>,
            TError,
            { data?: NonReadonly<LegacyConfirmationControlViewModel> },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyControlConfirmationData>>,
    TError,
    { data?: NonReadonly<LegacyConfirmationControlViewModel> },
    TContext
> => {
    return useMutation(
        getLegacyControlConfirmationDataMutationOptions(options),
        queryClient
    );
};
export const legacyControlCreateControlResultPreview = (
    legacyControl?: NonReadonly<LegacyControl>,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.post(
        `/v1/Control/CreateControlResultPreview`,
        legacyControl,
        options
    );
};

export const getLegacyControlCreateControlResultPreviewMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyControlCreateControlResultPreview>>,
        TError,
        { data?: NonReadonly<LegacyControl> },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyControlCreateControlResultPreview>>,
    TError,
    { data?: NonReadonly<LegacyControl> },
    TContext
> => {
    const mutationKey = ["legacyControlCreateControlResultPreview"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyControlCreateControlResultPreview>>,
        { data?: NonReadonly<LegacyControl> }
    > = (props) => {
        const { data } = props ?? {};

        return legacyControlCreateControlResultPreview(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyControlCreateControlResultPreviewMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlCreateControlResultPreview>>
>;
export type LegacyControlCreateControlResultPreviewMutationBody =
    | NonReadonly<LegacyControl>
    | undefined;
export type LegacyControlCreateControlResultPreviewMutationError =
    AxiosError<unknown>;

export const useLegacyControlCreateControlResultPreview = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyControlCreateControlResultPreview>>,
            TError,
            { data?: NonReadonly<LegacyControl> },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyControlCreateControlResultPreview>>,
    TError,
    { data?: NonReadonly<LegacyControl> },
    TContext
> => {
    return useMutation(
        getLegacyControlCreateControlResultPreviewMutationOptions(options),
        queryClient
    );
};
export const legacyControlNextOccurrence = (
    legacyControlControllerPostNextOccurrence?: NonReadonly<LegacyControlControllerPostNextOccurrence>,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<LegacyNextOccurrence>> => {
    return axios.post(
        `/v1/Control/NextOccurrence`,
        legacyControlControllerPostNextOccurrence,
        options
    );
};

export const getLegacyControlNextOccurrenceMutationOptions = <
    TError = AxiosError<void>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof legacyControlNextOccurrence>>,
        TError,
        { data?: NonReadonly<LegacyControlControllerPostNextOccurrence> },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof legacyControlNextOccurrence>>,
    TError,
    { data?: NonReadonly<LegacyControlControllerPostNextOccurrence> },
    TContext
> => {
    const mutationKey = ["legacyControlNextOccurrence"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof legacyControlNextOccurrence>>,
        { data?: NonReadonly<LegacyControlControllerPostNextOccurrence> }
    > = (props) => {
        const { data } = props ?? {};

        return legacyControlNextOccurrence(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type LegacyControlNextOccurrenceMutationResult = NonNullable<
    Awaited<ReturnType<typeof legacyControlNextOccurrence>>
>;
export type LegacyControlNextOccurrenceMutationBody =
    | NonReadonly<LegacyControlControllerPostNextOccurrence>
    | undefined;
export type LegacyControlNextOccurrenceMutationError = AxiosError<void>;

export const useLegacyControlNextOccurrence = <
    TError = AxiosError<void>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof legacyControlNextOccurrence>>,
            TError,
            { data?: NonReadonly<LegacyControlControllerPostNextOccurrence> },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof legacyControlNextOccurrence>>,
    TError,
    { data?: NonReadonly<LegacyControlControllerPostNextOccurrence> },
    TContext
> => {
    return useMutation(
        getLegacyControlNextOccurrenceMutationOptions(options),
        queryClient
    );
};
